import React from 'react';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';

import SimpleSelect from './SimpleSelect';

interface SelectProps extends Record<string, any> {
  name: string;
  onChange?: ((e: React.ChangeEvent<HTMLSelectElement>) => void) | null;
}

export default function Select({
  name,
  onChange = null,
  ...selectProps
}: SelectProps) {
  const {
    formFieldErrors,
    formFieldId,
    formFieldValue,
    handleFormFieldChange
  } = useFormContext(name);

  return (
    <SimpleSelect
      errors={formFieldErrors}
      id={formFieldId}
      name={name}
      onChange={onChange || handleFormFieldChange}
      value={formFieldValue}
      {...selectProps}
    />
  );
}
